var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImBookingConfirmReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327,
    height: 32,
    viewBox: "0 0 327 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M327 0v32h-17c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6h-8c0-3.314-2.686-6-6-6s-6 2.686-6 6H0V0h327z",
    transform: "translate(-24 -592) translate(24 592)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImBookingConfirmReceipt);
export default __webpack_public_path__ + "static/media/im-booking-confirm-receipt.34a3a636.svg";
export { ForwardRef as ReactComponent };